
export default function(o, rollData, onTogglePlay, videoFiles){

  var projectLabel = o.util.getTranslation(o, 'project')
  var rollLabel = o.util.getTranslation(o, 'roll')

  var projectNumber = rollData.roll.roll.split('-')[0]
  var rollNumber = rollData.roll.roll.split('-')[1]

  var start = 0

  var projectDiv =
    $('<div>')
    .css({
      display: 'inline-block',
      margin: '0.3rem',
    })
    .html(`${projectLabel} ${projectNumber}`)

  var rollDiv =
    $('<div>')
    .css({
      display: 'inline-block',
      margin: '0.3rem',
    })
    .html(`${rollLabel} ${rollNumber}`)

  var timecodeDiv =
    o.component.timecode(o)

  var playDiv =
    o.component.play(o, true, onTogglePlay)

  var downloadTitle = 
    $('<div>')
    .html(o.util.getTranslation(o,'download'))
    .css({
      margin: '0.3rem 0.2rem',
      display: 'inline-block',
    })

  var generateDownloadButton = function(quality){
    var token = o.store('token')
    var videoFile = `omb_${rollData.roll.roll}_${quality}_wm.mp4`
    var videoUrl = o.util.getUrl('downloadWatermark', quality) + videoFile + '?token=' + token
    return $('<a>')
    .css({
      textDecoration: 'none',
    })
    .attr({
      download: videoFile,
      href: videoUrl,
    })
    .append([
      o.component.button(o, quality, function(){})
      .css({
        margin: '0.3rem 0.2rem',
      })
      .click(function(){
        o.log('rollDownload', rollData.roll.roll, quality)
      }),
    ])
  }

  var calcStillHref = function(startSec){
    var token = o.store('token')
    var start = o.util.secondsToSmpte(startSec)
    var url = o.util.getUrl('downloadScreenshotWatermark')
    var roll = rollData.roll.roll
    var href = `${url}?roll=${roll}&start=${start}&token=${token}`
    return  href
  }

  var generateDownloadStillButton = function(quality){
    var href = calcStillHref(0)
    return $('<a>')
    .attr({
      href: href,
      download: true,
    })
    .css({
      textDecoration: 'none',
    })
    .append([
      o.component.button(o, 'jpg', function(){})
      .css({
        margin: '0.3rem 0.2rem',
      })
      .click(function(){
        o.log('stillDownload', rollData.roll.roll, href)
      }),
    ])
  }

  var downloadButton1080 = generateDownloadButton('1080')
  var downloadButton720 = generateDownloadButton('720')
  var downloadButton480 = generateDownloadButton('480')
  var downloadButton360 = generateDownloadButton('360')
  var downloadButtonStill = generateDownloadStillButton()

  downloadButtonStill.update = function(currentTime){
    var href = calcStillHref(currentTime)
    downloadButtonStill
    .attr({
      href: href,
      download: true,
    })
  }

  var update = function(currentTime){
    downloadButtonStill.update(currentTime)
    timecodeDiv.update(currentTime)
  }

  var div =
    $('<div>')
    .css({
      textAlign: 'center',
      whiteSpace: 'nowrap',
      overflowY: 'auto',
      '-webkit-overflow-scrolling': 'touch',
      fontSize: o.fontSizeDef.s,
      padding: '0.8rem',
    })
    .append([
      projectDiv,
      o.component.spacer(o),
      rollDiv,
      o.component.spacer(o),
      timecodeDiv,
      o.component.spacer(o),
      playDiv,
    ])

  if(o.store('token') && !o.isTouch){

    div.append([
      o.component.spacer(o),
      downloadTitle,
    ])

    if(Config.resolutions[360]){
      div.append([downloadButton360])
    }

    if(Config.resolutions[480]){
      div.append([downloadButton480])
    }

    if(Config.resolutions[720]){
      div.append([downloadButton720])
    }

    if(Config.resolutions[1080]){
      div.append([downloadButton1080])
    }

    div.append([downloadButtonStill])

  }

  div.update = update
  div.togglePlay = playDiv.toggle

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/roll/footer/footer.js